import { Popper, PopperProps } from "@mui/material";

import { getMountPoint } from "helpers/functions";

export const ShadowPopper = (props: PopperProps) => (
  <Popper container={getMountPoint()} {...props} />
);
